import { faCircleChevronDown } from '@fortawesome/free-solid-svg-icons';
//import { faCircleChevronUp } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import React, { useState } from 'react';
import { Collapse } from 'react-bootstrap';
import '../styles/Resources.css';

export default function Collapsible(props) {
    const [open, setOpen] = useState(false)
    return (
        <div className="question">
            <label htmlFor={props.id} id="drop" >
                <input type="checkbox" id={props.id} className="check" data-target="#collapse" aria-controls="collapse" onClick={() => setOpen(!open)}  />
                <FontAwesomeIcon
                    id="drop-down-icon"
                    style={{ color: "##003C71", maxWidth: 20 }}
                    size="3x"
                    icon={faCircleChevronDown}
                    
                />
            </label>
            <h1 className="question-headers" style={{ paddingTop: "12px", paddingBottom: "12px" }}>{props.label}</h1>
            <Collapse in={open}>
                <div id="collapse">
                    {props.children}
                </div>
            </Collapse>
        </div>
    )
}